import { ReactNode } from 'react'

import RocketLaunchTwoToneIcon from '@mui/icons-material/RocketLaunchTwoTone'
import BuildTwoToneIcon from '@mui/icons-material/BuildTwoTone'
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone'
import ListAltTwoToneIcon from '@mui/icons-material/ListAltTwoTone'

export interface MenuItem {
  link?: string
  icon?: ReactNode
  badge?: string
  items?: MenuItem[]
  name: string
  submenu?: SubMenuItems[]
}

export interface SubMenuItems {
  link?: string
  icon?: ReactNode
  name: string
}

const menuItems: MenuItem[] = [
  {
    name: 'Launchpad',
    icon: RocketLaunchTwoToneIcon,
    submenu: [
      {
        name: 'Presales',
        link: '/launchpad',
        icon: ListAltTwoToneIcon
      },
      {
        name: 'Start or Manage',
        link: '/start-launchpad',
        icon: BuildTwoToneIcon
      }
    ]
  },
  {
    name: 'Lock',
    icon: LockTwoToneIcon,
    submenu: [
      {
        name: 'View Lockers',
        link: '/locker'
      },
      {
        name: 'Lock LP Tokens',
        link: '/lp-tokens'
      },
      {
        name: 'Lock Tokens',
        link: '/lock-tokens'
      }
    ]
  }
]

export default menuItems
